module.exports = __webpack_public_path__ + "assets/img/thumb_ch1_news-item-1.11482959.jpg";